import { createAction } from '@reduxjs/toolkit';

import type { Status } from '../../constants';
import { actionTypes } from './types';

export const updateNetworkStatus = createAction<Status>(actionTypes.UPDATE_NETWORK_STATUS);
